<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

  <div class="d-flex align-items-center">
    <!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
  
    <div class="mr-auto">
      <el-form inline ref="form" :model="searchform">
        
          <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="시작"
                  end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" placeholder="선택" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input placeholder="키워드" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">검색</el-button>  
          </el-form-item>
      </el-form>
    
    </div>

  </div>
 <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" class="mt-3">
    <el-tab-pane label="회원" name="first">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  empty-text="데이타가 없습니다">


       <el-table-column
        
        label="날짜" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        label="롤링금" prop="tt1" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1)}}</el-button></template>
      </el-table-column>

      <el-table-column
        
        label="롤링금(카)" prop="tt1ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1ca)}}</el-button></template>
      </el-table-column>

      <el-table-column
        
        label="롤링금(슬)" prop="tt1st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1st)}}</el-button></template>
      </el-table-column>

        <el-table-column
        
        label="루징금" prop="tt2" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2)}}</el-button></template>
      </el-table-column>

      <el-table-column
        
        label="루징금(카)" prop="tt2ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2ca)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="루징금(슬)" prop="tt2st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2st)}}</el-button></template>
      </el-table-column>

  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane label="매장" name="two">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  empty-text="데이타가 없습니다">


       <el-table-column
        
        label="날짜" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        label="롤링금" prop="tt1" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="롤링금(카)" prop="tt1ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1ca)}}</el-button></template>
      </el-table-column>

      <el-table-column
        
        label="롤링금(슬)" prop="tt1st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1st)}}</el-button></template>
      </el-table-column>
        <el-table-column
        
        label="루징금" prop="tt2" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2)}}</el-button></template>
      </el-table-column>

 <el-table-column
        
        label="루징금(카)" prop="tt2ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2ca)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="루징금(슬)" prop="tt2st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2st)}}</el-button></template>
      </el-table-column>
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane label="총판" name="three">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  empty-text="데이타가 없습니다">


       <el-table-column
        
        label="날짜" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        label="롤링금" prop="tt1" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1)}}</el-button></template>
      </el-table-column>
<el-table-column
        
        label="롤링금(카)" prop="tt1ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1ca)}}</el-button></template>
      </el-table-column>

      <el-table-column
        
        label="롤링금(슬)" prop="tt1st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1st)}}</el-button></template>
      </el-table-column>
        <el-table-column
        
        label="루징금" prop="tt2" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="루징금(카)" prop="tt2ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2ca)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="루징금(슬)" prop="tt2st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2st)}}</el-button></template>
      </el-table-column>
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane label="부본사" name="four">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  empty-text="데이타가 없습니다">


       <el-table-column
        
        label="날짜" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        label="롤링금" prop="tt1" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="롤링금(카)" prop="tt1ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1ca)}}</el-button></template>
      </el-table-column>

      <el-table-column
        
        label="롤링금(슬)" prop="tt1st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'roling')">{{ formatMoney(scope.row.tt1st)}}</el-button></template>
      </el-table-column>
        <el-table-column
        
        label="루징금" prop="tt2" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2)}}</el-button></template>
      </el-table-column>

    
 <el-table-column
        
        label="루징금(카)" prop="tt2ca" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2ca)}}</el-button></template>
      </el-table-column>
      <el-table-column
        
        label="루징금(슬)" prop="tt2st" align="center">
         <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope,'rosing')">{{ formatMoney(scope.row.tt2st)}}</el-button></template>
      </el-table-column>
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
  </el-tabs>
  <el-dialog
            :visible.sync="rdpDialog" :width="rdpw" class="rdp" :title="rdpTitle" :close-on-click-modal ="false">
            <div class="border-bottom py-3"><span class="text-danger"></span></div>
            <el-table
                :data="rdpIdData"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  prop="mem_id"
                  label="아이디" align="center">
                </el-table-column>

                <el-table-column
                  prop="mem_name"
                  label="닉네임" align="center">
                </el-table-column>

                <el-table-column
                  prop="money"
                  label="금액" align="center">
                  <template slot-scope="scope">
                     <el-button type="text" @click="moenyModel(scope)">{{formatMoney(scope.row.money)}}</el-button>
                  </template>
                </el-table-column>
                 <el-table-column
                  prop="a_code"
                  label="부본사-총판-매장" align="center" width="200">
                   <template slot-scope="scope">
                  {{ scope.row.a_code}}-{{ scope.row.b_code}}-{{ scope.row.c_code}}
                  </template>
                </el-table-column>
                
                 <el-table-column
                  prop="admin_id"
                  label="알본사" align="center">
                </el-table-column>

                 
                
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="rdpDialog = false">Close</el-button>
        
            </span>
          </el-dialog>
 <el-dialog
            :visible.sync="MonDialog" :width="rdpw" class="rdp" :close-on-click-modal ="false">
           
            <el-table
                :data="moneyData"
                style="width: 100%" v-loading="monLoading">
                <el-table-column
                  prop="mem_id"
                  label="아이디" align="center">
                </el-table-column>

                <el-table-column
                  prop="money"
                  label="금액" align="center">
                </el-table-column>
                <el-table-column
                  prop="doc"
                  label="내용" align="center">

                </el-table-column>

                <el-table-column
                  prop="add_time"
                  label="시간" align="center">
                </el-table-column>
    
              </el-table>
             <div style="height: 10px;"></div>
                      <el-footer class="d-flex align-items-center px-0  bg-white">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="mcurrentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="msize"
                          layout="prev, pager, next"
                          :total="mtotal"
                          @size-change="mhandleSizeChange"
                              @current-change="mhandleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer> 
            <span slot="footer" class="dialog-footer">
              <el-button @click="MonDialog = false">Close</el-button>
        
            </span>
          </el-dialog>
    
        
        
</div>
 </template>

 <script>
 
    export default {
      
      data(){
        return{
          moneyData:[],
          monLoading:false,
          MonDialog:false,
          rdpTitle:'',
          rdpw:'700px',
          rdpIdData:[],
          user_type:'',
          type:'',
          rdpDialog:false,
          activeName: 'first',
          tapidx:"0",
          domain:window.sessionStorage.getItem('domain'),
            qa:[],
             colorObj:{
              '0':'text-danger',
              '1':'text-primary',
              '2':'text-success',
             
             
            },
            valObj:{
              '0':'대기',
              '1':'완료',
              '2':'보류',
             
             
            },
          searchform:{
            keyword:'',
            time:[],
            searchOptions:[
             
             {
              label:'아이디',
              value:'mem_id'
            }
            ],
           
            value:'',
          


          },
           pickerOptions: {
          },
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
        valueOption:'아이디',
          
            
         mtotal:0,
          msize:0,
          total:0,
          size:0,
          loading: false,
           editIndex:-1,
           creatModel:false,
           tableData: [],
           mcurrentPage:1,
                currentPage:1,
                multipleSelection:[],
                mPage:'',
             
               
          }
          
          
        },
        created() {
          

          this.getList();
          
      
    },
      
      methods:{
        moenyModel(e){
          this.mPage = e
          this.MonDialog = true
          this.monLoading = true
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/roling_rosing_date_byid?mem_id='+e.row.mem_id+'&date='+this.rdpTitle+'&type='+this.type+'&page='+this.mcurrentPage;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },  
            }).then((response) =>{ 
                     this.monLoading =false
                     console.log('mtotal=',response.data.data.total)
                     this.moneyData =response.data.data.data
                     this.mtotal = response.data.data.total
                     this.mcurrentPage = response.data.data.current_page
                     this.msize =response.data.data.per_page
                     
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
               this.monLoading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
        rdpModel(e,t){
          this.rdpDialog = true
          this.loading = true
          this.rdpTitle=e.row.date
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/roling_rosing_date_by?gubun='+t+'&date='+e.row.date+'&user_type='+this.user_type+'&type='+this.type;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },  
            }).then((response) =>{ 
                     this.loading =false
                     console.log('rdpdata=',response.data.data)
                     this.rdpIdData =response.data.data
                     
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })

        },
           handleClick(tab, event) {
              //console.log(tab, event);
              this.tapidx=tab.index
              this.getList(this.tapidx)
      },
          getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
         if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    
      
           // 搜索事件
      searchEvent(){

          this.getList(this.tapidx);
          this.currentPage=1;
             

        },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList(this.tapidx);
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList(this.tapidx);
              this.loading= true
            },
         mhandleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.msize = val
              this.moenyModel(this.mPage);
              this.monLoading= true

            },
            mhandleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.mcurrentPage = val
              this.moenyModel(this.mPage);
              this.monLoading= true
            },  
        getList(v){

               //console.log(v) 
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

               this.type='9';
               this.user_type='user';
               if(v=='0')
               {
                 //this.type='9';

               }
               if(v=='1')
               {
                 this.type='12';
                 this.user_type='pt';
               }
               if(v=='2')
               {
                 this.type='6';
                 this.user_type='pt';
               }
               if(v=='3')
               {
                 this.type='8';
                 this.user_type='pt';
               }

              
          this.loading = true

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/roling_rosing_date?type='+this.type+'&s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data)
                     this.tableData =response.data.data
                     this.total = response.data.total
                     this.currentPage = response.data.current_page
                     this.size =response.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
              

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
        
        
      
      
      
        
      }
  }
</script>

 <style scoped>
 .bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
>>>.el-dialog__headerbtn{
  z-index: 100;
}

</style>


// WEBPACK FOOTER //
// src/views/urdp/list.vue